<template>
  <ul v-if="!$store.getters.isAuthorized">
    <li>
      <router-link to="/">
        Home
      </router-link>
    </li>
    <!-- <li>
      <router-link to="/components">
        Components
      </router-link>
    </li>
    <li>
      <router-link to="/about">
        About
      </router-link>
    </li> -->
    <li>
      <router-link to="/contact">
        Contact
      </router-link>
    </li>
  </ul>
  <ul v-else-if="$store.getters.currentUser.isStudent">
    <li>
      <router-link to="/dashboard/user">
        Dashboard
      </router-link>
    </li>
    <li>
      <router-link to="/counselors">
        Individual Sessions
      </router-link>
    </li>
    <li>
      <router-link to="/workshops">
        Wellbeing Workshops
      </router-link>
    </li>
    <li>
      <router-link to="/resources">
        Additional Resources
      </router-link>
    </li>
    <li>
      <router-link to="/users/faq">
        F.A.Q.
      </router-link>
    </li>
    <li v-if="campusHasCrisisFeature">
      <a class="fake-link" @click="$refs.help.show()">
        Crisis Services
      </a>
      <get-help-modal ref="help" ok-text="Close"/>
    </li>
  </ul>
  <ul v-else-if="$store.getters.currentUser.isCounselor" >
    <li>
      <router-link to="/dashboard/counselor">
        My Dashboard
      </router-link>
    </li>
    <li>
      <router-link to="/availability">
        My Availability
      </router-link>
    </li>
    <li>
      <router-link to="/sessions/individual">
        My Sessions
      </router-link>
    </li>
    <li>
      <router-link to="/counselor/workshops">
        My Wellbeing Workshops
      </router-link>
    </li>
    <li>
      <router-link to="/clients">
        My Clients
      </router-link>
    </li>
    <!-- <li>
      <router-link to="/resources">
        Resources
      </router-link>
    </li> -->
  </ul>
  <ul v-else-if="$store.getters.currentUser.isCollegeAdmin" >
    <li>
      <router-link to="/dashboard/college">
        Dashboard
      </router-link>
    </li>
    <li>
      <router-link to="/college/users/session-outcomes">
        Session Outcomes
      </router-link>
    </li>
  </ul>
  <ul v-else-if="$store.getters.currentUser.isAdmin">
    <li>
      <router-link to="/dashboard/admin">
        Dashboard
      </router-link>
    </li>
    <li>
      <router-link to="/events">
        Events
      </router-link>
    </li>
    <li>
      <router-link to="/bettermynd-admin/workshops">
        Wellbeing Workshops
      </router-link>
    </li>
    <li>
      <router-link to="/accounts">
        Accounts
      </router-link>
    </li>
    <li>
      <router-link to="/appointments">
        Sessions
      </router-link>
    </li>
    <li>
      <router-link to="/bettermynd-admin/reports/feedback">
        Feedback
      </router-link>
    </li>
    <li>
      <router-link to="/bettermynd-admin/payroll">
        Payroll
      </router-link>
    </li>
  </ul>
</template>

<script>
import GetHelpModal from '@/crisis/GetHelpModal.vue'

export default {
  name: 'NavigationMenu',
  components: {
    GetHelpModal,
  },
  computed:{
    campusHasCrisisFeature(){
      return !!this.$store.getters.currentUser.school.bettermynd_crisis_phone;
    }
  }
};
</script>

<style lang="scss" scoped>
.fake-link {
  cursor: pointer;
}
</style>
